import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import img from "../assets/mudaala.jpg";

const FadeIn = ({ children, delay = 0, className = "" }) => {
    const [visible, setVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );
        if (ref.current) observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div
            ref={ref}
            className={`transition-all duration-700 ease-out ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"} ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </div>
    );
};

export default function FeaturedProduct() {
    return (
        <section className="relative py-24 bg-slate-950 overflow-hidden ">
            {/* Ambient background */}
            <div className="absolute top-0 right-0 w-[600px] py-20 h-[600px] bg-emerald-500/5 blur-[150px] rounded-full pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-[500px] py-20 h-[500px] bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 relative py-10 z-10">
                <div className="grid lg:grid-cols-2 gap-16 items-center">

                    {/* Left: Content */}
                    <div className="space-y-8">
                        <FadeIn>
                            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold bg-amber-500/10 text-amber-400 border border-emerald-500/20">
                                <i className="bi bi-stars" aria-hidden="true" />
                                Featured Product
                            </div>
                        </FadeIn>

                        <FadeIn delay={100}>
                            <div>
                                <h2 className="text-5xl md:text-6xl font-black text-white mb-2 font-heading tracking-tight">
                                    Omudaala
                                </h2>
                                <p className="text-xl md:text-2xl text-amber-400 font-medium">
                                    Fresh Produce, Delivered from Trusted Local Vendors
                                </p>
                            </div>
                        </FadeIn>

                        <FadeIn delay={200}>
                            <p className="text-slate-400 text-lg leading-relaxed max-w-lg">
                                Omudaala is our innovative digital marketplace that connects customers
                                with trusted local fruit and vegetable vendors. Enjoy fresh, high-quality
                                produce, convenient ordering, and fast delivery while supporting local
                                businesses in your community.
                            </p>
                        </FadeIn>

                        <FadeIn delay={300}>
                            <div className="flex flex-wrap items-center gap-6 text-sm text-slate-500">
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-check-circle-fill text-amber-500" aria-hidden="true" />
                                    Fresh & Local
                                </span>
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-check-circle-fill text-amber-500" aria-hidden="true" />
                                    Fast Delivery
                                </span>
                                <span className="flex items-center gap-2">
                                    <i className="bi bi-check-circle-fill text-amber-500" aria-hidden="true" />
                                    Support Local Business
                                </span>
                            </div>
                        </FadeIn>

                        <FadeIn delay={400}>
                            <a
                                href="https://omudaala.milestoneanddelight.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center mb-2 md:mb-0  gap-2 px-8 py-4 rounded-full bg-amber-500 text-slate-950 font-bold hover:bg-amber-400 hover:shadow-lg hover:shadow-amber-500/20 hover:-translate-y-0.5 transition-all duration-300"
                            >
                                Explore Omudaala
                                <i className="bi bi-arrow-right" aria-hidden="true" />
                            </a>
                            <Link to="/featured-products" className="inline-flex items-center ml-5 gap-4 px-8 py-4 rounded-full border border-amber-500 text-amber-500 font-bold hover:bg-amber-500 hover:text-slate-950 hover:shadow-lg hover:shadow-amber-500/20 hover:-translate-y-0.5 transition-all duration-300">
                                View More
                                <i className="bi bi-arrow-right" aria-hidden="true" />
                            </Link>
                        </FadeIn>
                    </div>

                    {/* Right: Visual Mockup */}
                    <FadeIn delay={200}>
                        <div className="relative">
                            {/* <img src={img} alt="" /> */}
                            <img src={img} alt="" className="w-full rounded-2xl border border-slate-800 shadow-2xl" />
                        </div>
                    </FadeIn>
                </div>
            </div>
        </section>
    );
}